/** @format */

import mutations from "./mutations";
import getters from "./getters";
import actions from "./actions";

export default {
  namespaced: true,
  state() {
    return {
      complianceTypes: [],
      complianceCalenderItems: [],
      singleComplianceTypeArchives: [],
      singleComplianceItem: [],
      submittedFilesByPractice: [],
      practicesForCompliance: [],
    };
  },
  mutations: mutations,
  actions: actions,
  getters: getters,
};
